export const GAME_REGISTRY = Object.freeze([
  Object.freeze({
    id: "ea_fc",
    legacyGameKey: "eafc",
    displayName: "EA SPORTS FC",
    shortName: "FC",
    enabled: true,
    defaultSelected: true,
    icon: "FC",
    logo: null,
    primaryColor: "#ff2bd6",
    secondaryColor: "#7a2bff",
    supportedPlatforms: Object.freeze(["crossplay"]),
    supportedModes: Object.freeze(["tournament", "single"]),
    tournamentTypes: Object.freeze(["evening", "nightly", "special", "community"]),
    ruleset: "ea_fc_standard",
    sortOrder: 10,
  }),
  Object.freeze({
    id: "rocket_league",
    legacyGameKey: "rocket_league",
    displayName: "Rocket League",
    shortName: "RL",
    enabled: false,
    defaultSelected: false,
    icon: "RL",
    logo: null,
    primaryColor: "#38bdf8",
    secondaryColor: "#f97316",
    supportedPlatforms: Object.freeze([]),
    supportedModes: Object.freeze([]),
    tournamentTypes: Object.freeze([]),
    ruleset: "rocket_league_standard",
    availabilityLabel: "Coming soon...",
    sortOrder: 20,
  }),
]);
